import AliceCarousel from "react-alice-carousel";

import "react-alice-carousel/lib/alice-carousel.css";

export * from "react-alice-carousel";

// `export default from…` is still experimental
export default AliceCarousel;
